import {
    BlockWrapper,
    ChildrenBlock,
    smartProps,
    useInspectorControl,
    defineBlock,
    useEditor,
} from '@smartfire/js-block-engine';
import { Dashicon } from '@wordpress/components';
import Inspector from './inspector';
import style from './block.module.scss';
import clsx from 'clsx';

const ImageTextColRight = ({ image, type, background, isHeightFixed }) => {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();

    return (
        <BlockWrapper.Div className={style.block}>
            {type === 'image' && (
                <div className={clsx(style.image, isHeightFixed && style.heightFixed)}>
                    {image ? (
                        <img src={image.url} alt={image.alt} />
                    ) : (
                        <>{isEditing && <Dashicon className={style.icon} icon="format-image" />}</>
                    )}
                </div>
            )}
            {type === 'encart' && (
                <div className={clsx(style.encart, background === 'white' && style.blue)}>
                    <ChildrenBlock
                        className={style.encartInner}
                        gutenbergEditorConfig={{
                            orientation: 'vertical',
                            allowedBlocks: [
                                'core/paragraph',
                                'core/heading',
                                'core/list',
                                'smartfire/button',
                                'smartfire/spacer',
                            ],
                            template: [['core/paragraph', {}]],
                        }}
                    />
                </div>
            )}
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: ImageTextColRight,
    smartProps: {
        type: smartProps.string.withDefault('image'),
        image: smartProps.image,
        isHeightFixed: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Colonne image et text droite',
        parent: ['smartfire/image-text'],
    },
});
